<div class="igntr-theme flex-1 bg-[var(--background-color)]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] pt-[16px] pb-[8px] md:px-[40px] md:pt-[24px] md:pb-[12px] flex flex-col gap-2"
  >
    <app-page-hero [title]="documentTypeName || 'documentList'"></app-page-hero>
  </div>

  <div class="max-w-[1180px] mx-auto px-[16px] md:px-[40px] pb-[100px]">
    <div class="bg-white border border-slate-200/70 rounded-xl">
      <div
        class="hidden md:grid grid-cols-[minmax(0,1fr)] gap-3 px-4 py-2.5 bg-slate-50/60 border-b border-slate-200/70 text-[14px] font-semibold tracking-[0.08em] text-slate-500"
      >
        <div>{{ "name" | transloco }}</div>
      </div>

      @if (!documents) {
        <app-spinner></app-spinner>
      }

      @for (document of documents; track document.id) {
        <a
          class="group grid grid-cols-[minmax(0,1fr)] gap-3 px-4 py-3 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/60 transition-colors items-center"
          href="{{ document.documentPath }}"
          target="_blank"
          rel="noopener"
        >
          <div class="text-[14px] font-medium text-slate-900 truncate">
            {{ document.title }}
          </div>
        </a>
      } @empty {
        @if (documents) {
          <p class="text-muted px-4 py-3 text-[14px]">
            {{ "noItemsFound" | transloco }}
          </p>
        }
      }
    </div>
  </div>
</div>
